import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";

@Component({
  templateUrl: '500.component.html'
})
export class P500Component implements OnInit {

  constructor(private title: Title) {}

  ngOnInit() {
    this.title.setTitle("Internal Server Error");
  }

}
